import {findJournalSetting} from '../../../journal/src/_reducers/findJournalSetting.fn';
import {Settings} from 'app/_interfaces/settings.interface';
import {JournalDefaultSettings2, JournalSettingsKeys} from 'projects/settings/src/lib/journal-settings/journal-settings.defaults2';

export const getSettingValue = <T>(settings: Settings, key: JournalSettingsKeys): T => {
	const setting = findJournalSetting(settings, key);
	return setting?.value as T;
};

export const getDefaultValue = (key: JournalSettingsKeys) => {
	return JournalDefaultSettings2.find(s => s.key === `journal.${key}`)?.value;
};
